export const ROOT = 'root';
export const ADMIN = 'admin';
